import { measureSvgText } from './measureSvgText';
import { truncateText } from '@ardoq/graph-labeling';

const truncateSvgText = truncateText(measureSvgText);
export { truncateSvgText };
